import { Component, computed, inject } from '@angular/core';
import { CartItemStateService } from '../../../services/cart-item-state.service';
import { LibModulesWolcModule } from '../../lib-modules-wolc.module';

@Component({
  selector: 'btlib-order-package-items',
  standalone: true,
  imports: [LibModulesWolcModule],
  templateUrl: './order-package-items.component.html',
  styleUrl: './order-package-items.component.scss'
})
export class BtOrderPackageItemsComponent {
  state = inject(CartItemStateService);
  packageItems = this.state.packageItems;
  hasPackageItems = computed(() => (this.packageItems() ?? []).length > 0);

  updateQuantity(itemId: number, quantity: number): void {
    this.state.updatePackageItemQuantity(itemId, quantity);
  }
}
